import { render, staticRenderFns } from "./productkinds.vue?vue&type=template&id=42b49266&"
import script from "./productkinds.vue?vue&type=script&lang=js&"
export * from "./productkinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports